import React from 'react';
import { CheckIcon, SunIcon } from 'lucide-react';
import { Countdown } from './Countdown';
const includes = ['5 Tomos completos · Principiante → Experto', '5 Bonos estratégicos (valor $89 USD)', 'Orientado al mercado solar de España y Latinoamérica', '100% PDF descargable · acceso de por vida'];
export function PricingSection() {
  return <section className="w-full bg-ink-950 py-20" id="precios" aria-labelledby="precios-title" data-id="element-154" data-mp="1jb1tmicqb28t">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6" data-id="element-155" data-mp="1ncn0nn2l0mb3">
        <Countdown label="Precio de lanzamiento — cierra en" note="Después sube el precio. No vuelve." progress={68} data-id="element-156" data-mp="1s8lw1umbv4l0" />

        <div className="mt-14 text-center" data-id="element-157" data-mp="227t5w7tush3d">
          <h2 id="precios-title" className="font-display text-3xl font-900 leading-tight text-white sm:text-4xl" data-id="element-158" data-mp="226i42djyxjew">
            Un solo pack. Todo incluido.
          </h2>
          <p className="mt-3 text-slate-400" data-id="element-159" data-mp="7ul8q9ientek">
            Acceso de por vida. Sin suscripciones. Sin letra pequeña.
          </p>
        </div>

        <div className="mt-10 rounded-2xl border border-gold bg-ink-900 p-7 shadow-panel sm:p-10" data-id="element-160" data-mp="1hpy9zzx61aqp">
          <div className="grid gap-8 sm:grid-cols-[1fr_auto] sm:items-center" data-id="element-161" data-mp="1cqv3sc5g8yh5">
            <div data-id="element-162" data-mp="1cosfpxnuxff2">
              <h3 className="font-display text-2xl font-800 uppercase leading-tight tracking-wide text-white sm:text-3xl" data-id="element-163" data-mp="17rsa1nux6eoh">
                Código Solar 360°
              </h3>
              <p className="mt-2 text-sm text-slate-400" data-id="element-164" data-mp="25dg627ngquzh">
                Ideal para: dueños de casa de 25 a 55 años que quieren pasarse al solar sin que los estafen.
              </p>

              <ul className="mt-6 grid gap-2.5" data-id="element-165" data-mp="1vfrygh4rdszw">
                {includes.map(item => <li key={item} className="flex gap-2.5 text-[15px] leading-relaxed text-slate-200" data-id="element-166" data-mp="1rf80xcg9wnd8">
                    <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-leaf-400" aria-hidden="true" data-id="element-167" data-mp="k3r50owy9gdt" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="sm:min-w-[240px] sm:border-l sm:border-ink-800 sm:pl-8 sm:text-center" data-id="element-168" data-mp="mh4gvlkomarb">
              <p className="text-lg text-slate-500 line-through" data-id="element-169" data-mp="7kdgb8z9ut04">$69 USD</p>
              <p className="mt-1 font-display text-6xl font-900 leading-none text-gold" data-id="element-170" data-mp="ciewnm5bce7w">$17</p>
              <p className="mt-2 text-xs uppercase tracking-[0.2em] text-slate-400" data-id="element-171" data-mp="3uwxxe0f0jm8d">
                USD · Pago único
              </p>
            </div>
          </div>

          <a href="#checkout" className="mt-9 flex items-center justify-center gap-2 rounded-xl bg-gold px-6 py-4 font-display text-base font-800 uppercase tracking-wide text-ink-950 transition-[transform,background-color] duration-150 ease-smooth hover:bg-gold-400 active:scale-[0.985] sm:text-lg" data-id="element-172" data-mp="3k37zpo0bqi3">
            <SunIcon className="h-5 w-5" aria-hidden="true" data-id="element-173" data-mp="3fz5fx2pwonrj" />
            Quiero mi Código Solar
          </a>
          <p className="mt-4 text-center text-[13px] text-slate-400" data-id="element-174" data-mp="2xabhbmmfslr4">
            Garantía 7 días · Pago seguro · Acceso en 5 minutos
          </p>
        </div>
      </div>
    </section>;
}